import React from 'react';
import Modal from 'app/components/Modal';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import modalStyles from 'shared/components/modalStyles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import messages, { FormattedMessage } from 'shared/messages/messages';

import { getAspectRatio } from 'app/utils/Utils';

import {
    setPrintSizes,
    selectPrintSizes,
    selectPrints,
    unselectPrints,
    unselectMoments,
    clearSelectedPrintSizes,
} from 'shared/actions/cartActions'

const styles = () => ({
    inputGroup: {
        padding: '0.3rem 0'
    },
    selectionContainer: {
        display: 'grid',
        // gridTemplateColumns: 'auto auto',
        justifyContent: 'center',
        rowGap: '10px',
        columnGap: '3em',
    },
    selection: {},
    selectionItem: {
        margin: 'auto',
    },
    printCountOption: {
        width: '3em',
        textAlign: 'center'
    },
    ...modalStyles()
});

class ImagePrintSizeSelection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedPrintSizes: []
        }
    }

    saveSelectedPrints = () => {
        this.props.onClose();
    }

    async removePrints() {
        const {
            unselectPrints,
            user,
            momentId,
            purchased,
            unselectMoments,
            clearSelectedPrintSizes
        } = this.props;

        let v2 = true;
        let clearAll = true;
        await unselectPrints(user.story_id, [momentId], v2, clearAll);
        await clearSelectedPrintSizes(user.story_id, momentId);

        // if the moment is purchased, then clear the cart item record.
        // normally the digital isn't unselected when the print is,
        // so unselecting a print only updates the cart item record.
        // but if the moment has been purchased then the digital can't be selected,
        // and the cart item should be cleared.
        // handling this with the unselectPrints endpoint would be nice
        // but appears complicated, so going with this for now
        if (purchased) {
            await unselectMoments(user.story_id, [momentId]);
        }
    }

    incrementCount = (sizeId, sizeDesc, momentId, thumbUrl, printCount, momentHeight, momentWidth) => {
        const { setPrintSizes, user, selectPrints, selectPrintSizes, selectedPrintSizes } = this.props;
        const selectedSizes = [...selectedPrintSizes];
        let count = printCount + 1;

        const selectedSize = selectedSizes.find(x => x.print_size_id == sizeId && x.moment_id == momentId);
        if (selectedSize) {
            const selectedIndex = selectedSizes.indexOf(selectedSize);
            selectedSize.print_count = count;
            selectedSizes[selectedIndex] = selectedSize;
        } else {
            selectedSizes.push({
                print_size_id: sizeId, moment_id: momentId, print_size: sizeDesc, story_id: user.story_id,
                user_id: user.id, thumb_url: thumbUrl, print_count: count, moment_height: momentHeight, moment_width: momentWidth
            });
        }
        const params = {
            print_size_id: sizeId,
            print_size: sizeDesc,
            moment_id: momentId,
            thumb_url: thumbUrl,
            print_count: count,
            moment_height: momentHeight,
            moment_width: momentWidth
        }

        let v2 = true;
        selectPrints(user.story_id, [momentId], v2).then(() => {
            selectPrintSizes(user.story_id, params);
        });

        this.setState({ selectedPrintSizes: selectedSizes });
        setPrintSizes(selectedSizes);
    }

    decrementCount = (sizeId, sizeDesc, momentId, thumbUrl, printCount, momentHeight, momentWidth) => {
        const { setPrintSizes, user, unselectPrints, selectPrintSizes, selectedPrintSizes } = this.props;
        const selectedSizes = [...selectedPrintSizes];
        const selectedSize = selectedPrintSizes.find(x => x.print_size_id == sizeId && x.moment_id == momentId);

        if (printCount == 0) {
            return
        }

        let count = printCount - 1;

        if ((count) == 0) {
            const selectedIndex = selectedSizes.indexOf(selectedSize);
            selectedSizes.splice(selectedIndex, 1);
        } else {
            if (selectedSize) {
                const selectedIndex = selectedSizes.indexOf(selectedSize);
                selectedSize.print_count = count;
                selectedSizes[selectedIndex] = selectedSize;
            } else {
                selectedSizes.push({
                    print_size_id: sizeId, moment_id: momentId, print_size: sizeDesc, story_id: user.story_id,
                    user_id: user.id, thumb_url: thumbUrl, print_count: count, moment_height: momentHeight, moment_width: momentWidth
                });
            }
        }
        const params = {
            print_size_id: sizeId,
            print_size: sizeDesc,
            moment_id: momentId,
            thumb_url: thumbUrl,
            print_count: count,
            moment_height: momentHeight,
            moment_width: momentWidth
        }

        let v2 = true;
        unselectPrints(user.story_id, [momentId], v2).then(() => {
            selectPrintSizes(user.story_id, params)
        });

        this.setState({ selectedPrintSizes: selectedSizes });
        setPrintSizes(selectedSizes);
    }

    renderImageSelection() {
        const { classes, printSizes, momentId, momentHeight, momentWidth, momentPrintSizes, thumbUrl, selectedPrintSizes, settings } = this.props;

        let sizeSelection = [];

        let momentAspect = getAspectRatio(momentWidth, momentHeight);
        let momentAspectRev = [...momentAspect].reverse().join("");

        let availablePrintSizes = printSizes;
        let addAspectsAvailable = false;
        if (momentPrintSizes.length) {
            availablePrintSizes = momentPrintSizes;
            addAspectsAvailable = true;
        }

        for (var printSize of availablePrintSizes) {
            var selected = selectedPrintSizes.find(x => x.moment_id == momentId && x.print_size_id == printSize.id);
            sizeSelection.push(
                {
                    id: printSize.id,
                    size: printSize.size,
                    printHeight: printSize.print_height,
                    printWidth: printSize.print_width,
                    moment_id: momentId,
                    thumb_url: thumbUrl,
                    print_count: selected ? selected.print_count : 0,
                    height: momentHeight,
                    width: momentWidth
                }
            );
        }

        let slide = {};

        let gridCols = 'auto auto';
        if (availablePrintSizes.length == 1) {
            gridCols = 'auto';
        }

        slide.component = (
            <div style={{ marginBottom: '24px'}}>
                <div className={classes.modalHeader}>
                    <span style={{ fontWeight: 600 }}><FormattedMessage {...messages.kiosk_print_size_select_header} /></span>
                </div>
                <p><FormattedMessage {...messages.kiosk_print_size_select_instructions} /></p>
                <div className={classes.selectionContainer} style={{ gridTemplateColumns: gridCols }}>
                    {
                        sizeSelection.map((item) => {
                            let match = null;
                            if (settings.show_aspect) {
                                let printAspect = getAspectRatio(item.printWidth, item.printHeight);
                                if (printAspect == momentAspect || printAspect == momentAspectRev || addAspectsAvailable) {
                                    match = <CheckCircleIcon sx={{ color: 'green', fontSize: '1.5em', float: 'right' }} />
                                } else {
                                    match = <CancelIcon sx={{ color: 'red', fontSize: '1.5em', float: 'right' }} />
                                }
                            }

                            return <div className={classes.selection}>
                                {match}<label className={classes.selectionItem}>{item.size}</label>
                                <div className={classes.selectionItem}>
                                    <button onClick={() => this.decrementCount(item.id, item.size, item.moment_id, item.thumb_url, item.print_count, item.height, item.width)}> - </button>
                                    <input className={classes.printCountOption} type="text" value={item.print_count} />
                                    <button onClick={() => this.incrementCount(item.id, item.size, item.moment_id, item.thumb_url, item.print_count, item.height, item.width)}> + </button>
                                </div>
                            </div>

                        })
                    }
                </div>
            </div>
        );

        slide.nextLabel = <FormattedMessage {...messages.button_select} />;
        slide.onNext = () => this.saveSelectedPrints();
        slide.prevLabel = <FormattedMessage {...messages.button_remove_prints} />;
        slide.onBack = () => this.removePrints();
        slide.onBackClose = true;
        slide.forceBack = true;

        return slide;
    }


    render() {
        const slides = [];
        slides.push(this.renderImageSelection());
        return <Modal slides={slides} open={this.props.isOpen} onClose={() => this.props.onClose()} />;
    }
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    printSizes: state.kioskReducer.printSizes,
    selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
    selectedPrintSizes: state.cartReducer.selectedPrintSizes
});

export default connect(mapStateToProps, { setPrintSizes, selectPrintSizes, selectPrints, unselectPrints, unselectMoments, clearSelectedPrintSizes })(withStyles(styles)(ImagePrintSizeSelection));
